export enum OfferCurrentView {
    "None" = 0,
    "OfferCustomer" = 1, //oferty
    "OfferRequest" = 2, //zapytania ofertowe
    "OfferRetailer" = 3, //oferty dla detalisty
}

export enum AccountCurrentView {
    MojeKonto = "/MyAccount",
    Finanse = "/Finances",
    Zamowienia = "/Orders",
    Oferty = "/Offers",
    Kontrahenci = "/Contractors",
    ZapisaneKoszyki = "/SavedBaskets"
}